var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpfulHumans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.5,
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.967 39.756C53.862 37.782 55 35.291 55 32.574 55 26.183 48.732 21 41 21s-14 5.183-14 11.574c0 6.393 6.268 11.575 14 11.575 1.295 0 2.544-.157 3.734-.43L52.7 50l-.732-10.244z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 46.968c-2.11 1.132-4.607 1.786-7.282 1.786-1.27 0-2.493-.159-3.66-.434L23.093 55l.88-10.695C22.114 42.306 21 39.783 21 37.033c0-3.108 1.417-5.936 3.728-8.033",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-2.77c0-3.477 2.889-6.23 6.5-6.23s6.5 2.753 6.5 6.23v2.424M35 33.4c0 .293-.404.6-.8.6h-.4c-.396 0-.8-.307-.8-.6v-1.8c0-.292.404-.6.8-.6h.4c.396 0 .8.308.8.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 31.6c0-.293.404-.6.8-.6h.4c.396 0 .8.307.8.6v1.8c0 .292-.404.6-.8.6h-.4c-.396 0-.8-.308-.8-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 33c0 3.57-2.053 5.262-5 4.967"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulHumans);
export default __webpack_public_path__ + "static/media/helpful-humans.8261996fa4ebca3790b9c86e8823d2cc.svg";
export { ForwardRef as ReactComponent };